/* Pure line-key cart planning. No DOM, requests, storage, or property mutations. */
(function (root, factory) {
  'use strict';
  var model = factory();
  if (typeof module === 'object' && module.exports) module.exports = model;
  if (root) root.SoulyshineCartModel = model;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MAIN_ID = '_customily-upsell-main-id';
  var ADDON_ID = '_customily-upsell-id';
  var DESIGN_URL = '_customily-customization-url';

  function fail(code, message) {
    var error = new Error(message);
    error.code = code;
    throw error;
  }

  function props(item) { return item && item.properties || {}; }
  function value(item, name) {
    var found = props(item)[name];
    return found === undefined || found === null ? '' : String(found).trim();
  }
  function handle(item) {
    return String(item && (item.handle || item.product_handle) || '').toLowerCase();
  }
  function isProtectionPlan(item) {
    return handle(item) === 'the-2-year-jewelry-protection-plan' ||
      Boolean(value(item, '__inkbleApp_checkbox_id') || value(item, '__inkbleApp_master_product_id'));
  }
  function isEngravingFee(item) { var id = Number(item && item.variant_id); return id === 51761795170550 || id === 51807242911990; }
  function isAddon(item) {
    if (isEngravingFee(item)) return true;
    if (!item || value(item, '_ss_cu_offer') || isProtectionPlan(item) || value(item, MAIN_ID)) return false;
    if (value(item, ADDON_ID) || handle(item) === 'surcharge') return true;
    var title = String(item.product_title || item.title || '').toLowerCase();
    return Boolean(value(item, DESIGN_URL) &&
      /surcharge|engraving|add-on|addon|extra fee|customization fee/.test(title));
  }
  function isMain(item) { return !isAddon(item) && !isProtectionPlan(item); }

  // Explicit Customily IDs are authoritative. A URL is only a fallback when
  // the child has no ID; matching by variant/product/title is never sufficient.
  function candidatesFor(addon, items) {
    if (isEngravingFee(addon)) {
      var parentKey = addon.parent_relationship && addon.parent_relationship.parent_key;
      var group = value(addon, '_ss_back_engraving_group');
      return items.filter(function(item) { return !isEngravingFee(item) && (parentKey ? item.key === parentKey : group && value(item, '_ss_back_engraving_group') === group); });
    }
    if (!isAddon(addon)) return [];
    var id = value(addon, ADDON_ID);
    var url = value(addon, DESIGN_URL);
    if (!id && !url) return [];
    return items.filter(function (item) {
      // Matching bracelets retain design properties but never own the source necklace's fees.
      return item !== addon && !value(item, '_ss_cu_offer') && isMain(item) &&
        (id ? value(item, MAIN_ID) === id : value(item, DESIGN_URL) === url);
    });
  }
  function parentFor(addon, items) {
    var matches = candidatesFor(addon, Array.isArray(items) ? items : []);
    return matches.length === 1 ? matches[0] : null;
  }
  function cartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) fail('INVALID_CART', 'The cart could not be read. Please refresh and try again.');
    var seen = Object.create(null);
    cart.items.forEach(function (item) {
      if (!item || typeof item.key !== 'string' || !item.key ||
          item.key === '__proto__' || item.key === 'constructor' || item.key === 'prototype' || seen[item.key]) {
        fail('INVALID_CART', 'Cart item identities changed. Please refresh and try again.');
      }
      seen[item.key] = true;
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1) {
        fail('INVALID_CART', 'A cart item has an invalid quantity. Please refresh and try again.');
      }
    });
    return cart.items;
  }
  function validateQuantity(item, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      fail('INVALID_QUANTITY', 'Please enter a whole-number quantity.');
    }
    // Explicit removal is always allowed, even for a minimum-order rule.
    if (quantity === 0) return;
    var rule = item.quantity_rule || item.variant && item.variant.quantity_rule || {};
    var minimum = rule.min === undefined || rule.min === null ? 1 : rule.min;
    var increment = rule.increment === undefined || rule.increment === null ? 1 : rule.increment;
    var maximum = rule.max;
    if (!Number.isSafeInteger(minimum) || minimum < 1 ||
        !Number.isSafeInteger(increment) || increment < 1 ||
        minimum % increment !== 0 ||
        (maximum !== undefined && maximum !== null &&
          (!Number.isSafeInteger(maximum) || maximum < minimum || maximum % increment !== 0))) {
      fail('INVALID_QUANTITY_RULE', 'This item has an invalid quantity rule. Please use the full cart.');
    }
    if (quantity < minimum || (maximum !== undefined && maximum !== null && quantity > maximum) ||
        quantity % increment !== 0) {
      fail('QUANTITY_RULE', 'This quantity is unavailable for an item in this design.');
    }
  }
  function groups(cart) {
    var items = cartItems(cart);
    return items.filter(function (item) { return !parentFor(item, items); }).map(function (item) {
      return {
        item: item,
        addons: items.filter(function (addon) { return parentFor(addon, items) === item; })
      };
    });
  }

  function planChange(cart, key, quantity) {
    var items = cartItems(cart);
    var item = items.find(function (line) { return line.key === key; });
    if (!item) fail('STALE_LINE', 'This cart item changed. Please refresh and try again.');
    if (isEngravingFee(item)) throw new Error("Change the charm quantity to update its engraving fee.");
    validateQuantity(item, quantity);
    if (item.quantity === quantity) return {};
    var updates = {};

    if (isProtectionPlan(item) && quantity > 0) {
      var otherPlanQuantity = items.reduce(function (sum, line) {
        return sum + (line !== item && isProtectionPlan(line) ? line.quantity : 0);
      }, 0);
      if (quantity + otherPlanQuantity > 1) {
        fail('PROTECTION_LIMIT', 'Only one jewelry protection plan is needed per order.');
      }
    }
    updates[item.key] = quantity;

    if (isMain(item)) {
      items.forEach(function (addon) {
        var matches = candidatesFor(addon, items);
        if (matches.indexOf(item) === -1) return;
        if (matches.length !== 1) {
          fail('AMBIGUOUS_GROUP', 'The fees for this design could not be matched safely. Please use the full cart.');
        }
        var target = 0;
        if (quantity > 0) {
          // Reduce the fraction first, avoiding intermediate multiplication
          // overflow and rejecting fractional child quantities without rounding.
          var a = addon.quantity;
          var b = item.quantity;
          while (b) { var remainder = a % b; a = b; b = remainder; }
          var divisor = item.quantity / a;
          if (quantity % divisor !== 0) {
            fail('UNSAFE_RATIO', 'This quantity cannot preserve the fees for this design. Please use the full cart.');
          }
          target = (quantity / divisor) * (addon.quantity / a);
          if (!Number.isSafeInteger(target)) {
            fail('UNSAFE_RATIO', 'This quantity cannot preserve the fees for this design. Please use the full cart.');
          }
        }
        validateQuantity(addon, target);
        if (target !== addon.quantity) updates[addon.key] = target;
      });

      // Only the explicit removal of the final matching master product permits
      // protection-plan cleanup. An ATC snapshot can temporarily lack a master.
      if (quantity === 0 && item.product_id !== undefined && item.product_id !== null) {
        var masterId = String(item.product_id);
        var remains = items.some(function (line) {
          return line !== item && isMain(line) && String(line.product_id) === masterId;
        });
        if (!remains) {
          items.forEach(function (plan) {
            if (isProtectionPlan(plan) && value(plan, '__inkbleApp_master_product_id') === masterId &&
                value(plan, '__inkbleApp_checkbox_can_remove_when_trigger_remove').toLowerCase() === 'true') {
              updates[plan.key] = 0;
            }
          });
        }
      }
    }
    return updates;
  }

  function planIntegrity(cart) {
    var plans = cartItems(cart).filter(isProtectionPlan);
    var updates = {};
    // This is the only background-safe normalization. Never delete an apparent
    // orphan: Customily may still be adding the parent in a separate request.
    plans.forEach(function (plan, index) {
      var target = index === 0 ? 1 : 0;
      if (plan.quantity !== target) {
        validateQuantity(plan, target);
        updates[plan.key] = target;
      }
    });
    return updates;
  }


  return {
    isAddon: isAddon,
    isProtectionPlan: isProtectionPlan,
    parentFor: parentFor,
    groups: groups,
    planChange: planChange,
    planIntegrity: planIntegrity
  };
});
